import {createAction, props} from '@ngrx/store';
import {IStore} from '../../../shared/shared-models/store/store';
import {
  StockItem,
  StockItemUpdateObj,
} from '../../../shared-utilities/models-old/datastructures';
import {IPaginationData} from '../../../shared/shared-models/pagination/pagination-data';
import {ISearchableFields} from '../../../shared/shared-models/type-sense/default-searchable-fields';
import {IFacetCounts, ITypeSenseApiDoc} from '../../../shared/shared-models/type-sense/type-sense-types';
import {IDepartment} from '../../../shared/shared-models/stock/departments';
import {IGridHeaderMenu} from '../../../shared/shared-models/grid-menu/header-menu';
import {ColDef} from 'ag-grid-community';
import {ISharedStoreSettings} from '../../../shared/shared-models/firebase/shared-store-settings';
import {IGlobalError} from 'src/app/shared/shared-components/components/global-error-display/models/global-error';
import {IFirebaseQuery} from '../../../shared/shared-models/firebase/firebase-queries';
import {IDisableStockItemRule, IEnableStockItemRule, TLineColour} from '../../settings-new/models';
import {IBulkChangeExcludedItem, IBulkChangeRow} from '../models/stock-manager-bulk-change.model';

//#region TYPESENSE API DOCS

export const getTypeSenseApiDocForSelectedStore = createAction(
  '[STOCK MANAGER][TypeSense API Doc] Get Typesense API Doc for Selected Store',
);

export const getTypeSenseApiDocForSelectedStoreSuccess = createAction(
  '[STOCK MANAGER][TypeSense API Doc] Get Typesense API Doc for Selected Store Success',
  props<{apiDocs: ITypeSenseApiDoc, storeId: string}>(),
);

//#endregion


// =======================================================================
// Stock Item
// =======================================================================
export const getAllTypesenseApiKeysForStores = createAction(
  '[Stock Manager][TypeSense] Get All Api Keys',
);

export const getAllTypesenseApiKeysForStoresSuccess = createAction(
  '[Stock Manager][TypeSense] Get All Api Keys Success',
  props<{apiDocs: Record<string, ITypeSenseApiDoc>}>(),
);

export const getAllTypesenseApiKeysForStoresFailure = createAction(
  '[Stock Manager][TypeSense] Get All Api Keys Failure',
  props<{error: IGlobalError}>(),
);

export const getAllStockItems = createAction(
  '[Stock Manager][Stock Item] Get All Stock Items',
  props<{idField: string; currentPage: number, pageSize: number}>(),
);

export const getAllStockItemsWithoutExistingSuppliers = createAction(
  '[Stock Manager][Stock Item] Get All Stock Items When Suppliers Do Not Exist ',
  props<{idField: string; currentPage: number, pageSize: number, store: IStore, selectedFields: ISearchableFields}>(),
);

export const getAllStockItemsWithExistingSuppliers = createAction(
  '[Stock Manager][Stock Item] Get All Stock Items When Suppliers Exist ',
  props<{
    idField: string;
    currentPage: number,
    pageSize: number,
    store: IStore,
    selectedFields: ISearchableFields,
    selectedStoreSuppliers: ISearchableFields
  }>(),
);

export const getAllStockItemsSuccess = createAction(
  '[Stock Manager][Stock Item] Get All Stock Items Success',
  props<{stockItems: StockItem[]; store: IStore, paginationData: IPaginationData, facetCounts: IFacetCounts}>(),
);

export const getAllStockItemsFailure = createAction(
  '[Stock Manager][Stock Item] Get All Stock Items Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

export const getNextPageForStockItems = createAction(
  '[Stock Manager][Pagination] Get Next Page For Stock Items',
);

export const getNextPageForStockItemsSuccess = createAction(
  '[Stock Manager][Pagination] Get Next Page For Stock Items Success',
  props<{stockItems: StockItem[]; store: IStore, nextPaginationData: IPaginationData}>(),
);

export const getNextPageForStockItemsFailure = createAction(
  '[Stock Manager][Pagination] Get Next Page For Stock Items Failure',
  props<{error: IGlobalError; store: IStore}>(),
);


// =======================================================================
// Search Results
// =======================================================================
export const setSearchableFields = createAction(
  '[Stock Manager][Search Results] Set Searchable Fields',
  props<{searchableFields: ISearchableFields}>(),
);

export const getSearchResultsForStockItems = createAction(
  '[Stock Manager][Search Results] Get Search Results For Stock Items',
  props<{idField: string}>(),
);

export const getSearchResultsForStockItemsSuccess = createAction(
  '[Stock Manager][Search Results] Get Search Results For Stock Items Success',
  props<{
    stockItems: StockItem[];
    store: IStore,
    paginationData: IPaginationData,
    facetCounts: IFacetCounts,
    stores: IStore[]
  }>(),
);

export const getSearchResultsForStockItemsFailure = createAction(
  '[Stock Manager][Search Results] Get Search Results For Stock Items Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

export const refreshStockData = createAction(
  '[STOCK MANAGER][Refresh Data] Refresh Stock Data',
);
// =======================================================================
// Pagination
// =======================================================================
export const getPaginationResultsForStockItems = createAction(
  '[Stock Manager][Pagination] Get Pagination Results For Stock Item [Grid]',
  props<{pageNumber: number}>(),
);

export const getPaginationResultsForStockItemsSuccess = createAction(
  '[Stock Manager][Pagination] Get Pagination Results For Stock Items Success [Grid]',
  props<{stockItems: StockItem[]; store: IStore, paginationData: IPaginationData, facetCounts: IFacetCounts}>(),
);

export const getPaginationResultsForStockItemsFailure = createAction(
  '[Stock Manager][Pagination] Get Pagination Results For Stock Items Failure [Grid]',
  props<{error: IGlobalError, store: IStore}>(),
);

// =======================================================================
// Page size
// =======================================================================
export const setPageSizeForSharedGrid = createAction(
  '[Stock Manager][Pagination] Set Page Size For Shared Grid',
  props<{pageSize: number}>(),
);

export const setPageSizeForSharedGridAtStoreId = createAction(
  '[Stock Manager][Pagination] Set Page Size For Shared Grid At Store Id',
  props<{pageSize: number; store: IStore, pageNumber: number}>(),
);

export const setStockManagerPaginationCurrentPage = createAction(
  '[Stock Manager][Pagination] Set Current Page',
  props<{pageNumber: number; store: IStore}>(),
);

// =======================================================================
// set Next Page
// =======================================================================
export const setNextPageForSharedGrid = createAction(
  '[Stock Manager][Pagination] Set Next Page For Shared Grid',
);

export const setNextPageForSharedGridAtStoreId = createAction(
  '[Stock Manager][Pagination] Set Next Page For Shared Grid At Store Id',
  props<{paginationData: IPaginationData; store: IStore}>(),
);

export const getNextPageForSharedGridSuccess = createAction(
  '[Stock Manager][Pagination] Get Next Page For Shared Grid Success',
  props<{store: IStore, stockItems: StockItem[]}>(),
);
export const getNextPageForSharedGridFailure = createAction(
  '[Stock Manager][Pagination] Get Next Page For Shared Grid Failure',
  props<{error: IGlobalError; store: IStore}>(),
);

// =======================================================================
// Suppliers
// =======================================================================
export const getSuppliersForStockManager = createAction(
  '[Stock Manager][Suppliers] Get Suppliers For Stock Manager',
  props<{store: IStore, firebaseQueries: IFirebaseQuery[], idField: string}>(),
);

export const getSuppliersForStockManagerSuccess = createAction(
  '[Stock Manager][Suppliers] Get Suppliers For Stock Manager Success',
  props<{suppliers: ISearchableFields, store: IStore}>(),
);

export const getSuppliersForStockManagerFailure = createAction(
  '[Stock Manager][Suppliers] Get Suppliers For Stock Manager Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

// Load suppliers for a single, arbitrary store (used by Add Stock Item multi-store selection).
// Side-effect free: only populates storeSuppliers[storeId] without touching grid loading state.
export const getStoreSuppliers = createAction(
  '[Stock Manager][Suppliers] Get Store Suppliers',
  props<{store: IStore}>(),
);

export const getStoreSuppliersSuccess = createAction(
  '[Stock Manager][Suppliers] Get Store Suppliers Success',
  props<{store: IStore; suppliers: ISearchableFields}>(),
);

export const getStoreSuppliersFailure = createAction(
  '[Stock Manager][Suppliers] Get Store Suppliers Failure',
  props<{store: IStore; error: IGlobalError}>(),
);

export const setSuppliersForStockManager = createAction(
  '[Stock Manager][Suppliers] Set Suppliers For Stock Manager',
  props<{suppliers: Record<string, ISearchableFields>}>(),
);

export const setSuppliersForStockManagerSuccess = createAction(
  '[Stock Manager][Suppliers] Set Suppliers For Stock Manager Success',
  props<{
    stockItems: StockItem[],
    store: IStore,
    paginationData: IPaginationData,
    facetCounts: IFacetCounts,
    suppliers: Record<string, ISearchableFields>
  }>(),
);

export const setSuppliersForStockManagerFailure = createAction(
  '[Stock Manager][Suppliers] Set Suppliers For Stock Manager Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

// =======================================================================
// Departments and SubDepartments
// =======================================================================
export const getStoreDepartmentsForStockManager = createAction(
  '[Stock Manager][Departments] Get Store Departments For Stock Manager',
);

export const getStoreDepartmentsForStockManagerSuccess = createAction(
  '[Stock Manager][Departments] Get Store Departments For Stock Manager Success',
  props<{store: IStore; departments: IDepartment[], storeSettings: ISharedStoreSettings}>(),
);

export const getStoreDepartmentsForStockManagerFailure = createAction(
  '[Stock Manager][Departments] Get Store Departments For Stock Manager Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

// Load departments for a single, arbitrary store (used by Add Stock Item multi-store selection).
// Side-effect free: only populates departments[storeId] without triggering a stock-items reload.
export const getStoreDepartments = createAction(
  '[Stock Manager][Departments] Get Store Departments',
  props<{store: IStore}>(),
);

export const getStoreDepartmentsSuccess = createAction(
  '[Stock Manager][Departments] Get Store Departments Success',
  props<{store: IStore; departments: IDepartment[]}>(),
);

export const getStoreDepartmentsFailure = createAction(
  '[Stock Manager][Departments] Get Store Departments Failure',
  props<{store: IStore; error: IGlobalError}>(),
);

// =======================================================================
// Filters
// =======================================================================
export const setStockItemFilters = createAction(
  '[Stock Manager][Filters] Set Stock Item Filters',
  props<{filters: Record<string, ISearchableFields>; preserveCurrentPage?: boolean}>(),
);

export const setStockItemFiltersSuccess = createAction(
  '[Stock Manager][Filters] Set Stock Item Filters Success',
  props<{
    stockItems: StockItem[],
    store: IStore,
    paginationData: IPaginationData,
    facetCounts: IFacetCounts,
    filters: Record<string, ISearchableFields>,
    clientFilteredStockItemsCache?: StockItem[],
  }>(),
);

export const setStockItemFiltersFailure = createAction(
  '[Stock Manager][Filters] Set Stock Item Filters Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

export const setStockItemClientFilterLoading = createAction(
  '[Stock Manager][Filters] Set Stock Item Client Filter Loading',
  props<{loading: boolean}>(),
);

export const clearClientFilteredStockItemsCache = createAction(
  '[Stock Manager][Filters] Clear Client Filtered Stock Items Cache',
  props<{storeId: string}>(),
);


// ====================================================================================================
// Get Disabling Rules
// ====================================================================================================
export const getStockItemDisablingRules = createAction(
  '[Stock Manager][Item Disabling] Get Stock Items Disabling Rules',
  (store?: IStore) => ({store}),
);

export const getStockItemDisablingRulesSuccess = createAction(
  '[Stock Manager][Item Disabling] Get Stock Items Disabling Rules Success',
  props<{store: IStore; rulesDoc: IDisableStockItemRule; enableRules?: IEnableStockItemRule}>(),
);

export const getStockItemDisablingRulesFailure = createAction(
  '[Stock Manager][Item Disabling] Get Stock Items Disabling Rules Failure',
  props<{error: IGlobalError}>(),
);

// ====================================================================================================
// Disable Items
// ====================================================================================================
export const setItemDisabledStatus = createAction(
  '[Stock Manager][Item Disabling] Set Item to be Disabled',
  props<{stockItem: StockItem, enable: boolean}>(),
);

export const setItemDisabledWithStoreID = createAction(
  '[Stock Manager][Item Disabling] Set Item to be Disabled With StoreID',
  props<{stockItem: StockItem; store: IStore}>(),
);

export const setDontDisplayModalAgain = createAction(
  '[Stock Manager][Item Disabling] Set Dont Display Modal Again',
);

// ====================================================================================================
// Edited Items
// ====================================================================================================

export const updateStockItemsWithEditedSuccess = createAction(
  '[Stock Manager][Edited Items] Update Stock Items with Edited Success',
  props<{stockItems: StockItem[], store: IStore, editedItems: StockItem[]}>(),
);

export const setEditedItem = createAction(
  '[Stock Manager][Edited Items] Set Edited Item',
  props<{stockItem: StockItem}>(),
);
export const setEditedItemAdd = createAction(
  '[Stock Manager][Edited Items] Add To Edited Items',
  props<{stockItem: StockItem, store: IStore}>(),
);
export const setEditedItemRemove = createAction(
  '[Stock Manager][Edited Items] Remove From Edited Items',
  props<{stockItem: StockItem, store: IStore}>(),
);

export const setEditedItemToLocalStorage = createAction(
  '[Stock Manager][Edited Items] Add Edited Item To Local Storage',
  props<{stockItem: StockItem, store: IStore}>(),
);

export const removeEditedItemFromLocalStorage = createAction(
  '[Stock Manager][Edited Items] Remove Edited Item From Local Storage',
);

export const getEditedItemsWithValueFromLocalStorage = createAction(
  '[Stock Manager][Edited Items] Set Edited Items With Value From Local Storage',
);

export const setEditedItemsWithValueFromLocalStorage = createAction(
  '[Stock Manager][Edited Items] Get Edited Items With Value From Local Storage',
  props<{editedItems: Record<string, Record<string, StockItem>>, store: IStore}>(),
);


export const setEditedItemsToStockPage = createAction(
  '[Stock Manager][Edited Items] Add The Edited Item To Stock Page',
);

export const exitStockManagerPreview = createAction(
  '[Stock Manager][Preview] Exit Stock Manager Preview',
  props<{store: IStore}>(),
);

export const getEditedItemsFromTypesense = createAction(
  '[Stock Manager][Edited Items] Get Edited Items from Typesense',
  props<{store: IStore}>(),
);

export const getEditedItemsFromTypesenseSuccess = createAction(
  '[Stock Manager][Edited Items] Get Edited Items from Typesense Success',
  props<{
    editedItemsFromTypesense: StockItem[];
    facetCounts: IFacetCounts;
    store: IStore,
    priceBandedItems: StockItem[]
  }>(),
);

export const getEditedItemsFromTypesenseFailure = createAction(
  '[Stock Manager][Edited Items] Get Edited Items from Typesense Failure',
  props<{error: IGlobalError; store: IStore}>(),
);

// ====================================================================================================
// Set Grid Menu Action
// ====================================================================================================
export const setStockManagerMenuActions = createAction(
  '[Stock Manager][Menu Actions] Set Stock Manager Menu Actions per Column',
  props<{gridHeaderMenu: IGridHeaderMenu}>(),
);


export const setStockManagerMenuActionsWithStore = createAction(
  '[Stock Manager][Menu Actions] Set Stock Manager Menu Actions per Column with Store Details',
  props<{store: IStore; gridHeaderMenu: IGridHeaderMenu}>(),
);

export const setStockManagerSortTye = createAction(
  '[Stock Manager][Menu Actions] Set Stock Manager Sort Type',
  props<{sortType: string}>(),
);

export const togglePriceBanding = createAction(
  '[Stock Manager][Menu Actions] Toggle PriceBanding ',
);

export const toggleAutoFillSupplierStockCode = createAction(
  '[Stock Manager][Table Settings] Toggle Auto Fill Supplier Stock Code',
);

export const setDontAskSupplierCodeAutoFillSession = createAction(
  '[Stock Manager][Supplier Code Auto Fill] Set Do Not Ask Again This Session',
);

export const checkSupplierCodeAutoFillOnSupplierChange = createAction(
  '[Stock Manager][Supplier Code Auto Fill] Check Supplier Code Auto Fill On Supplier Change',
  props<{
    stockItem: StockItem;
    newSupplierCode: string;
    previousSupplierCode: string;
  }>(),
);

export const clearStockManagerMenuActions = createAction(
  '[Stock Manager][Menu Actions] Clear Stock Manager Menu Actions ',
);


//===============================================================================================================
// Set Visible Fields
//===============================================================================================================
export const setStockManagerVisibility = createAction(
  '[Stock Manager][Visible Fields] Set Stock Manager Visible Fields',
  props<{colDef: ColDef[]; menuData: string[]}>(),
);

export const updateStockManagerSingleVisibleField = createAction(
  '[Stock Manager][Visible Fields] Update Single Visible Field For Stock Manager',
  props<{colId: string; value: boolean}>(),
);

// ====================================================================================================
// Get Line Colours
// ====================================================================================================
export const getLineColours = createAction(
  '[Stock Manager][Line Colour] Get Line Colours',
  props<{pageStoreDocument: string}>(),
);

export const getLineColoursSuccess = createAction(
  '[Stock Manager][Line Colour] Get Line Colours Success',
  props<{lineColours: TLineColour; selectedStore: IStore}>(),
);

export const getLineColoursFailure = createAction(
  '[Stock Manager][Line Colour] Get Line Colours Failure',
  props<{error: IGlobalError, store: IStore}>(),
);

// Load line colours for a single, arbitrary store (used by Add Stock Item multi-store selection).
// Side-effect free: only populates lineColours[storeId] without triggering a stock-items reload.
export const getStoreLineColours = createAction(
  '[Stock Manager][Line Colour] Get Store Line Colours',
  props<{store: IStore}>(),
);

export const getStoreLineColoursSuccess = createAction(
  '[Stock Manager][Line Colour] Get Store Line Colours Success',
  props<{store: IStore; lineColours: TLineColour}>(),
);

export const getStoreLineColoursFailure = createAction(
  '[Stock Manager][Line Colour] Get Store Line Colours Failure',
  props<{store: IStore; error: IGlobalError}>(),
);

// ====================================================================================================
// Set NGP And Price Incl
// ====================================================================================================
export const setPriceGpForStockManager = createAction(
  '[Stock Manager][Price] Set The Price, NGP for Stock Manager',
  props<{stockItem: StockItem, field: string}>(),
);

export const setPriceGpForStockMangerWithStoreID = createAction(
  '[Stock Manager][Price] Set The Price, NGP for Stock Manager for Store ID',
  props<{stockItem: StockItem; field: string; storeId: IStore}>(),
);

// ====================================================================================================
// Multiple Price Change Rules
// ====================================================================================================

export const showMultiplePriceChangeNotice = createAction(
  '[Stock Manager][Multiple Prices] Show Multiple Price Change Notice',
  props<{store: IStore}>(),
);

export const dismissMultiplePriceChangeNotice = createAction(
  '[Stock Manager][Multiple Prices] Dismiss Multiple Price Change Notice',
);

export const openMultiplePriceChangePreview = createAction(
  '[Stock Manager][Multiple Prices] Open Multiple Price Change Preview',
  props<{code: string}>(),
);

export const closeMultiplePriceChangePreview = createAction(
  '[Stock Manager][Multiple Prices] Close Multiple Price Change Preview',
);

// ====================================================================================================
// set Stock Updates For Stock Manger
// ====================================================================================================

export const setStockUpdatesForStockManger = createAction(
  '[Stock Manager][Update Firebase] Set Stock Updates On Firebase For Stock Manager',
  props<{
    itemsToUpdate: Record<string, StockItemUpdateObj>,
    multipleSuppliers: Record<string, string[]>
  }>(),
);

export const stockUpdateFailure = createAction(
  '[Stock Manager][Update Firebase] Set Stock Updates On Firebase For Stock Manager Failure',
  props<{error: IGlobalError}>(),
);

export const removeEditedItemsAfterStockUpdate = createAction(
  '[Stock Manager][Update Firebase] Remove Edited Items After StockUpdate',
  props<{store: IStore}>(),
);

export const undoAllEditsToStockManager = createAction(
  '[Stock Manager][Undo Edits] Remove Edited Items From Stock Manager',
);

// ====================================================================================================
// get Stock Manager Preview Columns
// ====================================================================================================


export const getStockManagerPreviewColumns = createAction(
  '[Stock Manager][Preview Columns] Get Stock Manager Preview Columns',
);

export const setStockManagerPreviewColumns = createAction(
  '[Stock Manager][Preview Column] Set Stock Manager Preview Columns',
  props<{columnData: {}}>(),
);

export const setStockManagerPreviewColumnsSuccess = createAction(
  '[Stock Manager][Preview Column] Set Stock Manager Preview Columns Success',
  props<{columnData: {}}>(),
);

export const setStockManagerPreviewColumnsFailure = createAction(
  '[Stock Manager][Preview Column] Set Stock Manager Preview Columns Failure',
  props<{error: IGlobalError}>(),
);

export const lockAllStockItems = createAction(
  '[STOCK_MANAGER][Bulk Edits] Lock All Stock items',
  props<{enable: boolean}>(),
);

export const lockAllStockItemsFailure = createAction(
  '[STOCK_MANAGER][Bulk Edits] Lock All Stock items Failure',
);

export const setItemsDisabledStatusBatch = createAction(
  '[Stock Manager][Item Disabling] Disable Items (batch)',
  props<{items: StockItem[]; enable: boolean}>(),
);

export const runStockDisableAudit = createAction(
  '[Stock Manager][Audit] Run Stock Disable Audit',
  props<{storeId: string}>(),
);

export const runStockDisableAuditSuccess = createAction(
  '[Stock Manager][Audit] Run Stock Disable Audit Success',
  props<{
    disabledRuleMismatches: StockItem[];
    missingDisableTag: StockItem[];
    partialDisableDescriptions: StockItem[];
    rulesConfigured: boolean;
    scannedCount: number;
    truncated: boolean;
  }>(),
);

export const runStockDisableAuditFailure = createAction(
  '[Stock Manager][Audit] Run Stock Disable Audit Failure',
  props<{errorMessage: string}>(),
);

export const applyStockDisableAuditRuleMismatch = createAction(
  '[Stock Manager][Audit] Apply Disable Rule Mismatches',
);

export const applyStockDisableAuditMissingTag = createAction(
  '[Stock Manager][Audit] Apply Missing Disable Tags',
);

export const applyStockDisableAuditPartialDescription = createAction(
  '[Stock Manager][Audit] Apply Partial Disable Descriptions',
);

export const showStockDisableAuditItems = createAction(
  '[Stock Manager][Audit] Show Audit Items',
  props<{notice: string; stockItems: StockItem[]; store: IStore}>(),
);

export const setBatchUpdateEditedItems = createAction(
  '[Stock Manager][Batch Update] Update Edited Items',
  props<{batchUpdateEditedItems: StockItem[], store: IStore}>(),
);

export const downloadFilteredItemsAsCSV = createAction(
  '[Stock Manager][Export] Download Filtered Items As CSV',
);

export const downloadFilteredItemsAsCSVSuccess = createAction(
  '[Stock Manager][Export] Download Filtered Items As CSV Success',
);


export const createNewStockItem = createAction(
  '[Stock Manager][Create New Stock Item] Create New Stock Item',
  props<{
    newStockItem: Record<string, StockItemUpdateObj>;
    storeIds?: string[];
    /**
     * Optional per-store payload. When provided, each store gets its own document map
     * (e.g. a different generated stock code per store). Falls back to `newStockItem` +
     * `storeIds` when omitted, preserving existing single-payload behaviour.
     */
    itemsByStore?: Record<string, Record<string, StockItemUpdateObj>>;
  }>(),
);

export const createNewStockItemSuccess = createAction(
  '[Stock Manager][Create New Stock Item] Create New Stock Item Success',
);

export const createNewStockItemFailure = createAction(
  '[Stock Manager][Create New Stock Item] Create New Stock Item Failure',
  props<{
    failed: { storeId: string; message?: string }[];
    succeededStoreIds: string[];
  }>(),
);

export const resetCreateNewStockItemSubmit = createAction(
  '[Stock Manager][Create New Stock Item] Reset Create New Stock Item Submit',
);


export const navigateToStoreSettings = createAction(
  '[Stock Manager][navigation] Navigate To Store Settings',
);

export const prepareBulkStockChanges = createAction(
  '[Stock Manager][Bulk Change] Prepare Bulk Stock Changes',
  props<{rows: IBulkChangeRow[]}>(),
);

export const prepareBulkStockChangesSuccess = createAction(
  '[Stock Manager][Bulk Change] Prepare Bulk Stock Changes Success',
  props<{excludedItems: IBulkChangeExcludedItem[]}>(),
);

export const prepareBulkStockChangesFailure = createAction(
  '[Stock Manager][Bulk Change] Prepare Bulk Stock Changes Failure',
  props<{error: IGlobalError}>(),
);

export const applyBulkStockChanges = createAction(
  '[Stock Manager][Bulk Change] Apply Bulk Stock Changes',
  props<{rows: IBulkChangeRow[]}>(),
);

export const setBulkChangeStatus = createAction(
  '[Stock Manager][Bulk Change] Set Bulk Change Status',
  props<{message: string}>(),
);

export const applyBulkStockChangesSuccess = createAction(
  '[Stock Manager][Bulk Change] Apply Bulk Stock Changes Success',
);

export const applyBulkStockChangesFailure = createAction(
  '[Stock Manager][Bulk Change] Apply Bulk Stock Changes Failure',
  props<{error: IGlobalError; cancelled: boolean}>(),
);

// =======================================================================
// Multi-Store Stock Grid
// =======================================================================

export const setMultiStoreSelectedStoreIds = createAction(
  '[Stock Manager][Multi-Store] Set Selected Store Ids',
  props<{storeIds: string[]}>(),
);

export const getMultiStoreStockItems = createAction(
  '[Stock Manager][Multi-Store] Get Stock Items',
  props<{currentPage?: number; pageSize?: number; searchedValue?: string}>(),
);

export const getMultiStoreStockItemsSuccess = createAction(
  '[Stock Manager][Multi-Store] Get Stock Items Success',
  props<{
    stockItems: StockItem[];
    paginationData: IPaginationData;
    facetCounts: IFacetCounts;
    storeColourMap: Record<string, string>;
  }>(),
);

export const getMultiStoreStockItemsFailure = createAction(
  '[Stock Manager][Multi-Store] Get Stock Items Failure',
  props<{error: IGlobalError}>(),
);

export const getMultiStoreStockItemsBeyondCap = createAction(
  '[Stock Manager][Multi-Store] Get Stock Items Beyond Prefix Cap',
  props<{paginationData: IPaginationData}>(),
);

export const setMultiStoreStockItemFilters = createAction(
  '[Stock Manager][Multi-Store] Set Stock Item Filters',
  props<{filters: Record<string, ISearchableFields>}>(),
);

export const setStockUpdatesForStore = createAction(
  '[Stock Manager][Update Firebase] Set Stock Updates For Specific Store',
  props<{
    store: IStore;
    itemsToUpdate: Record<string, StockItemUpdateObj>;
    multipleSuppliers: Record<string, string[]>;
  }>(),
);

export const finishStockUpdateForStore = createAction(
  '[Stock Manager][Update Firebase] Finish Stock Update For Store',
  props<{storeName: string; itemCount: number; failed: boolean; message?: string}>(),
);
